import React from "react";
import { spacing, textStyles, colors, primitives } from "@/ui/tokens";

export interface ToolEmptyStateProps {
  icon: React.ReactElement<{ style?: React.CSSProperties }>;
  message: string;
}

/** Standard empty state for tool displays — icon + message, centered. */
export function ToolEmptyState({ icon, message }: ToolEmptyStateProps) {
  const styledIcon = React.cloneElement(icon, {
    style: { fontSize: 40, color: primitives.neutral[300] },
  });

  return (
    <div
      style={{
        padding: spacing[6],
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: spacing[2],
        textAlign: "center",
      }}
    >
      {styledIcon}
      <p style={{ ...textStyles.body2, color: colors.text.muted, margin: 0 }}>
        {message}
      </p>
    </div>
  );
}
